/**
 * This code was AUTOGENERATED using the codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type Codec,
  type Decoder,
  type Encoder,
} from '@solana/kit';

export enum ClockField {
  Slot,
  EpochStartTimestamp,
  Epoch,
  LeaderScheduleEpoch,
  UnixTimestamp,
}

export type ClockFieldArgs = ClockField;

export function getClockFieldEncoder(): Encoder<ClockFieldArgs> {
  return getEnumEncoder(ClockField);
}

export function getClockFieldDecoder(): Decoder<ClockField> {
  return getEnumDecoder(ClockField);
}

export function getClockFieldCodec(): Codec<ClockFieldArgs, ClockField> {
  return combineCodec(getClockFieldEncoder(), getClockFieldDecoder());
}
